import { useRef } from "react";
import { useNavigate } from "react-router-dom";

const LOGO_URL = "/assets/wordmark-logo.png";
const LOGO_WEBP = "/assets/wordmark-logo.webp";

/**
 * Wordmark logo. Triple-tap within 1.3s navigates to /admin.
 */
export const Logo = ({ size = "medium", className = "" }) => {
  const navigate = useNavigate();
  const tapsRef = useRef([]);

  const sizes = {
    small: "h-10 md:h-12",
    medium: "h-16 md:h-20",
    large: "h-32 md:h-44",
    xlarge: "h-44 md:h-64",
    huge: "h-56 md:h-80",
  };

  const handleClick = (e) => {
    e.preventDefault();
    const now = Date.now();
    tapsRef.current = [...tapsRef.current, now].filter((t) => now - t < 1300);
    if (tapsRef.current.length >= 3) {
      tapsRef.current = [];
      navigate("/admin");
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`logo-pulse focus:outline-none ${className}`}
      aria-label="Councilman Wood — triple-tap for admin"
      data-testid="brand-logo"
    >
      <picture>
        <source srcSet={LOGO_WEBP} type="image/webp" />
        <img
          src={LOGO_URL}
          alt="Councilman Wood"
          width="720"
          height="720"
          fetchpriority="high"
          className={`${sizes[size]} w-auto no-select`}
          draggable={false}
          style={{
            filter: "drop-shadow(0 10px 30px rgba(0,0,0,0.45))",
          }}
        />
      </picture>
    </button>
  );
};
